import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Pagination from "@material-ui/lab/Pagination";
import * as XLSX from "xlsx";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";


import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

import { Avatar, CircularProgress, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, Switch, TextField, Tooltip, Typography } from "@material-ui/core";
import { UsersFilter } from "../../components/UsersFilter";
import { WhatsappsFilter } from "../../components/WhatsappsFilter";
import { StatusFilter } from "../../components/StatusFilter";
import useDashboard from "../../hooks/useDashboard";

import QueueSelectCustom from "../../components/QueueSelectCustom";
import moment from "moment";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";

import { blue, green } from "@material-ui/core/colors";
import { Facebook, Forward, History, Instagram, SaveAlt, WhatsApp } from "@material-ui/icons";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    height: "calc(100% - 48px)",
    overflowY: "hidden",
    gap: theme.spacing(1.5),
    background: theme.palette.fancyBackground,
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(1) },
  },

  // ===== HERO HEADER =====
  pageHeader: {
    width: "100%",
    padding: theme.spacing(2, 3),
    borderRadius: 20,
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #060D1F 0%, #0A1628 100%)"
      : "linear-gradient(135deg, #EEF4FF 0%, #E0ECFF 50%, #D0E4FF 100%)",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(0,102,255,0.2)"
      : "1px solid rgba(0,102,255,0.12)",
    boxShadow: "0 8px 32px rgba(0,102,255,0.08)",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: -40, right: -40,
      width: 160, height: 160,
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(0,102,255,0.1) 0%, transparent 70%)",
    },
  },
  pageHeaderInner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    zIndex: 1,
  },
  pageHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  pageHeaderIcon: {
    width: 48,
    height: 48,
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    color: "#fff",
    borderRadius: 14,
    fontSize: "1.3rem",
    flexShrink: 0,
    boxShadow: "0 8px 20px rgba(0,102,255,0.35)",
  },
  pageHeaderTitle: {
    fontWeight: 800,
    fontSize: "1.15rem",
    color: theme.palette.type === "dark" ? "#ffffff" : "#0A1628",
    letterSpacing: "-0.2px",
  },
  pageHeaderSubtitle: {
    marginTop: 2,
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.55)" : "rgba(10,22,40,0.55)",
    fontSize: "0.78rem",
    lineHeight: 1.4,
  },
  headerStats: {
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "center",
  },
  headerStatCard: {
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.8)",
    border: theme.palette.type === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(255,255,255,0.9)",
    borderRadius: 12,
    padding: theme.spacing(1, 2),
    textAlign: "center",
    backdropFilter: "blur(8px)",
  },
  headerStatNum: {
    fontWeight: 800,
    fontSize: "1.3rem",
    color: "#0066FF",
    lineHeight: 1,
  },
  headerStatLabel: {
    fontSize: "0.68rem",
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "rgba(10,22,40,0.5)",
    marginTop: 2,
  },
  headerChip: {
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: 10,
    padding: theme.spacing(1, 2),
    boxShadow: "0 4px 14px rgba(0,102,255,0.3)",
    border: "none",
    cursor: "default",
  },

  // ===== FILTER =====
  mainPaperFilter: {
    flex: 1,
    overflow: "visible",
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
    marginBottom: 0,
    boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
    ...theme.scrollbarStylesSoftBig,
  },
  filterTitle: {
    fontSize: "0.85rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  filterSubtitle: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  filterActionArea: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: { justifyContent: "flex-start", flexWrap: "wrap" },
  },
  filterBtn: {
    borderRadius: 10,
    height: 36,
    fontWeight: 700,
    fontSize: "0.8rem",
    textTransform: "none",
    paddingInline: 18,
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    color: "#ffffff",
    boxShadow: "0 4px 14px rgba(0,102,255,0.3)",
    "&:hover": { background: "linear-gradient(135deg, #0052CC 0%, #0088DD 100%)" },
  },
  exportBtn: {
    border: "1px solid rgba(0,102,255,0.25)",
    borderRadius: 10,
    color: "#0066FF",
    "&:hover": { background: "rgba(0,102,255,0.06)", border: "1px solid #0066FF" },
  },

  // ===== TABLE =====
  mainPaperTable: {
    flex: 1,
    overflow: "auto",
    height: "55vh",
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
    ...theme.scrollbarStylesSoftBig,
  },
  tableHeadCell: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,102,255,0.03)",
    borderBottom: `2px solid ${theme.palette.divider}`,
    whiteSpace: "nowrap",
    fontSize: "0.72rem",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  tableRow: {
    transition: "background 0.15s ease",
    "&:hover": {
      background: theme.palette.type === "dark" ? "rgba(0,102,255,0.05)" : "rgba(0,102,255,0.03)",
    },
  },
  statusChip: {
    fontWeight: 700,
    fontSize: "0.68rem",
    height: 20,
    borderRadius: 6,
  },
  pagerWrap: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.4),
  },
  tableCellText: {
    fontSize: "0.76rem",
  },
}));

const Reports = () => {
  const classes = useStyles();
  const history = useHistory();
  const { getReport } = useDashboard();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Defina o tamanho da página

  const [searchParam, setSearchParam] = useState("");
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  // const [tagIds, setTagIds] = useState([]);
  const [queueIds, setQueueIds] = useState([]);
  const [userIds, setUserIds] = useState([]);
  const [options, setOptions] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment("1", "D").format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [onlyRated, setOnlyRated] = useState(false);
  const [totalTickets, setTotalTickets] = useState(0);
  const [tickets, setTickets] = useState([]);

  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(null);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts", {
            params: { searchParam },
          });
          setOptions(data.contacts);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  // const handleSelectedTags = (selecteds) => {
  //   const tags = selecteds.map((t) => t.id);
  //   setTagIds(tags);
  // };

  const exportarGridParaExcel = async () => {
    setLoading(true); // Define o estado de loading como true durante o carregamento

    try {
      const data = await getReport({
        searchParam,
        contactId: selectedContactId,
        whatsappId: JSON.stringify(selectedWhatsapp),
        // tags: JSON.stringify(tagIds),
        users: JSON.stringify(userIds),
        queueIds: JSON.stringify(queueIds),
        status: JSON.stringify(selectedStatus),
        // tags: tagIds,
        dateFrom,
        dateTo,
        page: 1, // Passa o número da página para a API
        pageSize: 9999999, // Passa o tamanho da página para a API
        onlyRated: onlyRated ? "true" : "false"
      });


      const ticketsData = data.tickets.map(ticket => {
        // Convertendo o campo createdAt para um objeto Date
        const createdAt = new Date(ticket.createdAt);
        const closedAt = new Date(ticket.closedAt);

        const dataFechamento = closedAt.toLocaleDateString();
        const horaFechamento = closedAt.toLocaleTimeString();
        // Obtendo a data e a hora separadamente
        const dataCriacao = createdAt.toLocaleDateString(); // Obtém a data no formato 'dd/mm/aaaa'
        const horaCriacao = createdAt.toLocaleTimeString(); // Obtém a hora no formato 'hh:mm:ss'

        return {
          id: ticket.id,
          Conexão: ticket.whatsappName,
          Contato: ticket.contactName,
          Usuário: ticket.userName,
          Fila: ticket.queueName,
          Status: ticket.status,
          ÚltimaMensagem: ticket.lastMessage,
          DataAbertura: dataCriacao,
          HoraAbertura: horaCriacao,
          DataFechamento: ticket.closedAt === null ? "" : dataFechamento,
          HoraFechamento: ticket.closedAt === null ? "" : horaFechamento,
          TempoDeAtendimento: ticket.supportTime,
          nps: ticket.NPS,
        }
      });

      const ws = XLSX.utils.json_to_sheet(ticketsData);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'RelatorioDeAtendimentos');
      XLSX.writeFile(wb, 'relatorio-de-atendimentos.xlsx');


      setPageNumber(pageNumber); // Atualiza o estado da página atual
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false); // Define o estado de loading como false após o carregamento
    }

  };


  const handleFilter = async (pageNumber) => {
    setLoading(true); // Define o estado de loading como true durante o carregamento
    try {
      const data = await getReport({
        searchParam,
        contactId: selectedContactId,
        whatsappId: JSON.stringify(selectedWhatsapp),
        // tags: JSON.stringify(tagIds),
        users: JSON.stringify(userIds),
        queueIds: JSON.stringify(queueIds),
        status: JSON.stringify(selectedStatus),
        // tags: tagIds,
        dateFrom,
        dateTo,
        page: pageNumber, // Passa o número da página para a API
        pageSize: pageSize, // Passa o tamanho da página para a API
        onlyRated: onlyRated ? "true" : "false"
      });

      setTotalTickets(data.totalTickets.total);

      setTickets(data.tickets); // Se for a primeira página, substitua os tickets

      setPageNumber(pageNumber); // Atualiza o estado da página atual
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false); // Define o estado de loading como false após o carregamento
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setUserIds(users);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);
    setSelectedWhatsapp(whatsapp);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    setSelectedStatus(statusFilter);
  };
  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
      case "instagram":
        return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
      case "whatsapp":
        return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
      default:
        return "error";
    }
  };

  const renderOption = (option) => {
    if (option.number) {
      return <>
        {IconChannel(option.channel)}
        <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
          {option.name} - {option.number}
        </Typography>
      </>
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const handleSelectOption = (e, newValue) => {
    setSelectedContactId(newValue?.id || null);
    setSearchParam("");
  };

  const renderOptionLabel = option => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };
  const filter = createFilterOptions({
    trim: true,
  });

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };
  const renderContactAutocomplete = () => {
    return (
      <Grid xs={12} item>
        <Autocomplete
          fullWidth
          options={options}
          loading={loading}
          clearOnBlur
          autoHighlight
          freeSolo
          size="small"
          clearOnEscape
          getOptionLabel={renderOptionLabel}
          renderOption={renderOption}
          filterOptions={createAddContactOption}
          onChange={(e, newValue) => handleSelectOption(e, newValue)}
          renderInput={params => (
            <TextField
              {...params}
              label={i18n.t("newTicketModal.fieldLabel")}
              variant="outlined"
              autoFocus
              size="small"
              onChange={e => setSearchParam(e.target.value)}
              // onKeyPress={(e, newValue) => handleSelectOption(e, newValue)}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </Grid>
    )
  }

  return (
    <div className={classes.pageRoot}>
      {openTicketMessageDialog && (
        <ShowTicketLogModal
          isOpen={openTicketMessageDialog}
          handleClose={() => setOpenTicketMessageDialog(false)}
          ticketId={ticketOpen.id}
        />
      )}
      <Paper className={classes.pageHeader} elevation={0}>
        <div className={classes.pageHeaderInner}>
          <div className={classes.pageHeaderLeft}>
            <Avatar className={classes.pageHeaderIcon}>📊</Avatar>
            <div>
              <Typography className={classes.pageHeaderTitle}>{i18n.t("reports.title")}</Typography>
              <Typography className={classes.pageHeaderSubtitle}>
                Filtre atendimentos por período, equipe e status para extrair relatórios completos.
              </Typography>
            </div>
          </div>
          <div className={classes.headerStats}>
            <div className={classes.headerStatCard}>
              <Typography className={classes.headerStatNum}>{totalTickets}</Typography>
              <Typography className={classes.headerStatLabel}>Registros</Typography>
            </div>
            <Button disableElevation variant="contained" className={classes.filterBtn}
              style={{ textTransform: "none" }} onClick={() => handleFilter(pageNumber)}>
              Filtrar
            </Button>
          </div>
        </div>
      </Paper>

      <div style={{ display: "flex" }}>
        <Paper className={classes.mainPaperFilter} elevation={0}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography style={{ fontSize: 16, fontWeight: 700, color: "#1e293b" }}>
                Filtros de Relatorio
              </Typography>
              <Typography style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
                Refine por contato, canais, status, atendentes e periodo antes de consultar.
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              {renderContactAutocomplete()}
            </Grid>
            <Grid item xs={12} md={3}>
              <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
            </Grid>
            <Grid item xs={12} md={3}>
              <StatusFilter onFiltered={handleSelectedStatus} />
            </Grid>
            <Grid item xs={12} md={3}>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </Grid>
            <Grid item xs={12} md={3}>
              <QueueSelectCustom
                selectedQueueIds={queueIds}
                onChange={values => setQueueIds(values)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Data Inicial"
                type="date"
                value={dateFrom}
                variant="outlined"
                fullWidth
                size="small"
                onChange={(e) => setDateFrom(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Data Final"
                type="date"
                value={dateTo}
                variant="outlined"
                fullWidth
                size="small"
                onChange={(e) => setDateTo(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <div className={classes.filterActionArea}>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={onlyRated}
                      onChange={() => setOnlyRated(!onlyRated)}
                    />
                  }
                  label={i18n.t("reports.buttons.onlyRated")}
                />
                <Tooltip title="Exportar para Excel">
                  <IconButton onClick={exportarGridParaExcel} aria-label="Exportar para Excel" style={{ border: "1px solid #cbd5e1", borderRadius: 10 }}>
                    <SaveAlt />
                  </IconButton>
                </Tooltip>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter(pageNumber)}
                  size="small"
                  style={{ borderRadius: 10, height: 36, fontWeight: 700, textTransform: "none", paddingInline: 16 }}
                >
                  {i18n.t("reports.buttons.filter")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>

      </div>
      <Paper
        className={classes.mainPaperTable}
        variant="outlined"
      >
        <Table size="small" id="grid-attendants">
          <TableHead>
            <TableRow>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.id")}</TableCell>
              <TableCell align="left" className={classes.tableHeadCell}>{i18n.t("reports.table.whatsapp")}</TableCell>
              <TableCell align="left" className={classes.tableHeadCell}>{i18n.t("reports.table.contact")}</TableCell>
              <TableCell align="left" className={classes.tableHeadCell}>{i18n.t("reports.table.user")}</TableCell>
              <TableCell align="left" className={classes.tableHeadCell}>{i18n.t("reports.table.queue")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.status")}</TableCell>
              <TableCell align="left" className={classes.tableHeadCell}>{i18n.t("reports.table.lastMessage")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.dateOpen")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.dateClose")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.supportTime")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.NPS")}</TableCell>
              <TableCell align="center" className={classes.tableHeadCell}>{i18n.t("reports.table.actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {tickets.map((ticket) => (
                <TableRow key={ticket.id} className={classes.tableRow}>
                  <TableCell className={classes.tableCellText} align="center">{ticket.id}</TableCell>
                  <TableCell className={classes.tableCellText} align="left">{ticket?.whatsappName}</TableCell>
                  <TableCell className={classes.tableCellText} align="left">{ticket?.contactName}</TableCell>
                  <TableCell className={classes.tableCellText} align="left">{ticket?.userName}</TableCell>
                  <TableCell className={classes.tableCellText} align="left">{ticket?.queueName}</TableCell>
                  <TableCell className={classes.tableCellText} align="center">{ticket?.status}</TableCell>
                  <TableCell className={classes.tableCellText} align="left">{ticket?.lastMessage}</TableCell>
                  <TableCell className={classes.tableCellText} align="center">{ticket?.createdAt}</TableCell>
                  <TableCell className={classes.tableCellText} align="center">{ticket?.closedAt}</TableCell>
                  <TableCell className={classes.tableCellText} align="center">{ticket?.supportTime}</TableCell>
                  <TableCell className={classes.tableCellText} align="center">{ticket?.NPS}</TableCell>
                  <TableCell align="center">
                    <Typography
                      noWrap
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <Tooltip title="Logs do Ticket">
                        <History
                          onClick={() => {
                            setOpenTicketMessageDialog(true)
                            setTicketOpen(ticket)
                          }}
                          fontSize="small"
                          style={{
                            color: blue[700],
                            cursor: "pointer",
                            marginLeft: 10,
                            verticalAlign: "middle"
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Acessar Ticket">
                        <Forward
                          onClick={() => { history.push(`/tickets/${ticket.uuid}`) }}
                          fontSize="small"
                          style={{
                            color: green[700],
                            cursor: "pointer",
                            marginLeft: 10,
                            verticalAlign: "middle"
                          }}
                        />
                      </Tooltip>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton avatar columns={3} />}
            </>
          </TableBody>
        </Table>
      </Paper>

      <div className={classes.pagerWrap}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm={9} md={10}>
            <Pagination
              count={Math.ceil(totalTickets / pageSize)} // Calcula o nmero total de páginas com base no nmero total de tickets e no tamanho da página
              page={pageNumber} // Define a página atual
              onChange={(event, value) => handleFilter(value)} // Função de callback para mudanças de página
            />
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <FormControl
              margin="dense"
              variant="outlined"
              fullWidth
            >
              <InputLabel>
                {i18n.t("tickets.search.ticketsPerPage")}
              </InputLabel>
              <Select
                labelId="dialog-select-prompt-label"
                id="dialog-select-prompt"
                name="pageSize"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(e.target.value)
                }}
                label={i18n.t("tickets.search.ticketsPerPage")}
                fullWidth
                MenuProps={{
                  anchorOrigin: {
                    vertical: "center",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "center",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={5} >{"5"}</MenuItem>
                <MenuItem value={10} >{"10"}</MenuItem>
                <MenuItem value={20} >{"20"}</MenuItem>
                <MenuItem value={50} >{"50"}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>
    </div >
  );
};

export default Reports;
